import Title from "components/Title/Title";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Biclycle from "../../../../assets/bicycle.svg?react";
import "./i18n";
import "./requirements.scss";

const Requirements = () => {
  const { t, ready } = useTranslation();

  const requirements: string[] = useMemo(
    () => t("requirements:requirements", { returnObjects: true }),
    [t]
  );

  const renderRequirements = useCallback(() => {
    if (!ready || !Array.isArray(requirements)) return [];
    return requirements?.map((requirement, index) => {
      return (
        <div className="requirement-container">
          <h4 className="requirement-number">0{index + 1}.</h4>
          <p className="requirement-description">{requirement}</p>
        </div>
      );
    });
  }, [ready, requirements]);

  return (
    <div className="requirements-section" id="requirements">
      <div className="background-figure" />
      <div className="requirements-container">
        <div className="requirements-container-row">
          <div className="requirements-container-col-sm-5 requirements-col-12 bicycle-container">
            <Biclycle className="bicycle-image" />
          </div>
          <div className="requirements-container-col-sm-7 requirements-col-12">
            <div className="title-req-container">
              <Title title={t("requirements:title")} color="white" />
              <p>{t("requirements:description")}</p>
            </div>
            <div className="requirements-items-container">
              <Title title={t("requirements:secondTitle")} color="white" />
              <div className="requirement-items">{renderRequirements()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Requirements;
